/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Export_Erp_Contract_OmittedInputs */



/**
* | output |
* | --- |
* | "{count} contract periods are not in the file: they are settled by their purchase order." |
*
* @param {Admin_Export_Erp_Contract_OmittedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_erp_contract_omitted = /** @type {((inputs: Admin_Export_Erp_Contract_OmittedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Erp_Contract_OmittedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Vertragszeiträume sind nicht in der Datei: Sie werden über ihre Bestellung abgerechnet.`)
	return /** @type {LocalizedString} */ (`${i?.count} contract periods are not in the file: they are settled by their purchase order.`)
});